import { createRouteConfig } from 'modules/router/utils/createRouteConfig';

const NOTIFICATIONS_PATH = '/notifications/';

export const notificationsRoutesConfig = createRouteConfig(
  {
    notifications: {
      path: NOTIFICATIONS_PATH,
      generatePath: () => NOTIFICATIONS_PATH,
    },
  },
  NOTIFICATIONS_PATH,
);
